import client from './client';

export type ShutoffType = 'water' | 'electricity' | 'gas' | 'heating';

export interface Shutoff {
  id: number;
  type: ShutoffType;
  type_label?: string;
  reason?: string;
  reason_kk?: string;
  affected_addresses?: string[];
  district?: string;
  start_time: string;
  end_time?: string;
  is_active?: boolean;
  is_emergency: boolean;
  is_cancelled: boolean;
  notify_sent: boolean;
  created_at: string;
}

export interface ShutoffStats {
  total: number;
  active: number;
  upcoming: number;
  emergency_count: number;
  by_type: Record<string, number>;
}

export interface ShutoffListResponse {
  items: Shutoff[];
  total: number;
  page: number;
  size: number;
}

export interface ShutoffCreatePayload {
  type: ShutoffType;
  reason: string;
  reason_kk?: string;
  affected_addresses?: string[];
  district?: string;
  start_time: string;
  end_time?: string;
  is_emergency: boolean;
  send_push: boolean;
}

export interface ShutoffUpdatePayload {
  type?: ShutoffType;
  reason?: string;
  reason_kk?: string;
  affected_addresses?: string[];
  district?: string;
  start_time?: string;
  end_time?: string;
  is_emergency?: boolean;
}

export const shutoffsApi = {
  list: (params?: {
    type?: ShutoffType;
    district?: string;
    active_only?: boolean;
    page?: number;
    size?: number;
  }) =>
    client.get<ShutoffListResponse>('/api/admin/shutoffs', { params }),

  create: (data: ShutoffCreatePayload) =>
    client.post<Shutoff>('/api/admin/shutoffs', data),

  update: (id: number, data: ShutoffUpdatePayload) =>
    client.patch<Shutoff>(`/api/admin/shutoffs/${id}`, data),

  cancel: (id: number) =>
    client.delete<{ ok: boolean }>(`/api/admin/shutoffs/${id}`),

  stats: () =>
    client.get<ShutoffStats>('/api/admin/shutoffs/stats'),
};
